import { render, staticRenderFns } from "./PurchasePaymentView.vue?vue&type=template&id=9731a140"
import script from "./PurchasePaymentView.vue?vue&type=script&lang=js"
export * from "./PurchasePaymentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports